(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mwc-markets-core"), require("mwc-markets-plotter"));
	else if(typeof define === 'function' && define.amd)
		define(["mwc-markets-core", "mwc-markets-plotter"], factory);
	else if(typeof exports === 'object')
		exports["mwcMarketsTreasury"] = factory(require("mwc-markets-core"), require("mwc-markets-plotter"));
	else
		root["mwcMarketsTreasury"] = factory(root["mwcMarketsCore"], root["mwcMarketsPlotter"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__59__) {
return 